<section class="value-page">

  <header class="page-header">
    <div class="page-header-text">
      <h1 class="page-title">Value &amp; Impact</h1>
      <p class="page-sub">Business outcomes attributable to digital data capture, automation, and better decision support.</p>
    </div>
    <div class="filterbar">
      <span class="filter active">YTD</span>
      <span class="filter">All NAMCs</span>
      <span class="filter">Validated Benefits</span>
    </div>
  </header>

  <!-- KPI Cards -->
  <div class="kpi-grid">
    <article class="kpi-card">
      <span class="kpi-label">Events Collected</span>
      <div class="kpi-value">42.3M</div>
      <div class="kpi-delta">YTD</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Data Points Captured</span>
      <div class="kpi-value">512M</div>
      <div class="kpi-delta">YTD</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Manual Entries Avoided</span>
      <div class="kpi-value">18.7M</div>
      <div class="kpi-delta">Estimated</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Time Saved</span>
      <div class="kpi-value">125K h</div>
      <div class="kpi-delta">YTD estimate</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Paper Eliminated</span>
      <div class="kpi-value">1.3M</div>
      <div class="kpi-delta">Forms</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Estimated Value</span>
      <div class="kpi-value">$12.4M</div>
      <div class="kpi-delta kpi-delta--up">Validated + modeled</div>
    </article>
  </div>

  <!-- Cumulative Value chart + Value by NAMC -->
  <div class="content-grid two-col">

    <article class="panel chart-panel">
      <h3 class="section-title">Cumulative Value Over Time</h3>
      <div class="chart-area">
        <svg viewBox="0 0 620 220" aria-label="Cumulative value over time">
          <!-- Area fill -->
          <polygon class="area-fill"
            points="35,180 88,169 140,158 193,144 245,128 298,113 350,97 403,80 455,64 508,48 560,35 600,22 600,190 35,190"/>
          <!-- Line -->
          <polyline class="trend-line" stroke="#f58220"
            points="35,180 88,169 140,158 193,144 245,128 298,113 350,97 403,80 455,64 508,48 560,35 600,22"/>
          <!-- X axis -->
          <line class="chart-axis" x1="35" y1="190" x2="600" y2="190"/>
          <!-- Y-axis labels -->
          <text class="chart-label" x="30" y="193" text-anchor="end">$0</text>
          <text class="chart-label" x="30" y="145" text-anchor="end">$4M</text>
          <text class="chart-label" x="30" y="97" text-anchor="end">$8M</text>
          <text class="chart-label" x="30" y="48" text-anchor="end">$12M</text>
          <!-- X-axis labels -->
          <text class="chart-label" x="35" y="210" text-anchor="middle">Jan</text>
          <text class="chart-label" x="175" y="210" text-anchor="middle">Mar</text>
          <text class="chart-label" x="315" y="210" text-anchor="middle">May</text>
          <text class="chart-label" x="455" y="210" text-anchor="middle">Jul</text>
          <text class="chart-label" x="600" y="210" text-anchor="middle">Jul 20</text>
        </svg>
      </div>
    </article>

    <article class="panel">
      <h3 class="section-title">Value by NAMC</h3>
      <div class="bar-chart-list">
        <div class="bar-chart-row">
          <span class="bar-chart-label">TMMI</span>
          <div class="bar-bg"><div class="bar bar--orange" style="width: 94%"></div></div>
          <b>$3.2M</b>
        </div>
        <div class="bar-chart-row">
          <span class="bar-chart-label">TMMC</span>
          <div class="bar-bg"><div class="bar bar--orange" style="width: 79%"></div></div>
          <b>$2.7M</b>
        </div>
        <div class="bar-chart-row">
          <span class="bar-chart-label">TMMK</span>
          <div class="bar-bg"><div class="bar bar--orange" style="width: 71%"></div></div>
          <b>$2.4M</b>
        </div>
        <div class="bar-chart-row">
          <span class="bar-chart-label">TMMTX</span>
          <div class="bar-bg"><div class="bar bar--orange" style="width: 56%"></div></div>
          <b>$1.9M</b>
        </div>
        <div class="bar-chart-row">
          <span class="bar-chart-label">TMMMS</span>
          <div class="bar-bg"><div class="bar bar--orange" style="width: 47%"></div></div>
          <b>$1.6M</b>
        </div>
        <div class="bar-chart-row">
          <span class="bar-chart-label">TABC</span>
          <div class="bar-bg"><div class="bar bar--orange" style="width: 18%"></div></div>
          <b>$0.6M</b>
        </div>
      </div>
    </article>

  </div>

  <!-- Time Savings formula -->
  <article class="panel module-gap">
    <h3 class="section-title">Work Order Time Savings — Methodology</h3>
    <p class="muted" style="margin-bottom: 16px">Work orders created via EDC avoid manual Maximo data entry. Each EDC work order saves an estimated 13 minutes of technician time.</p>
    <div class="formula-flow">
      <div class="formula-block">
        <b>54,983</b>
        <span>EDC Work Orders</span>
      </div>
      <div class="formula-op">×</div>
      <div class="formula-block">
        <b>13 min</b>
        <span>Saved per WO</span>
      </div>
      <div class="formula-op">=</div>
      <div class="formula-block">
        <b>11,913 h</b>
        <span>Total Time Saved</span>
      </div>
      <div class="formula-op">×</div>
      <div class="formula-block">
        <b>$85 / h</b>
        <span>Avg Technician Cost</span>
      </div>
      <div class="formula-op">=</div>
      <div class="formula-block formula-block--highlight">
        <b>$1.01M</b>
        <span>WO Savings (YTD)</span>
      </div>
    </div>
    <div class="assumption-note">
      <strong>Assumption:</strong> 13-minute save per EDC work order is a conservative estimate based on the time avoided for manual Maximo data entry. Hourly rate is an approximate blended technician cost. Validated through TMMI pilot data.
    </div>
  </article>

  <!-- Work Order Savings by Shop -->
  <article class="panel module-gap">
    <div class="section-head-row">
      <div>
        <h3 class="section-title">Work Order Time Savings by Shop</h3>
        <p class="muted">Top shops ranked by EDC-attributed time savings. Select a NAMC to filter by plant.</p>
      </div>
      <div class="filter-pair">
        <label class="select-control">
          Plant / NAMC
          <select aria-label="Select NAMC">
            <option value="ALL">All NAMCs</option>
            <option value="TMMI">TMMI</option>
            <option value="TABC">TABC</option>
            <option value="TMMTX">TMMTX</option>
            <option value="TMMK">TMMK</option>
            <option value="TMMMS">TMMMS</option>
            <option value="TMMC">TMMC</option>
          </select>
        </label>
      </div>
    </div>
    <div class="table-wrap">
      <table class="data-table">
        <thead>
          <tr>
            <th>#</th>
            <th>NAMC</th>
            <th>Shop</th>
            <th class="numeric">EDC Work Orders</th>
            <th class="numeric">Hours Saved</th>
            <th class="numeric">Days Saved</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>TMMI</td>
            <td>Stamping 1</td>
            <td class="numeric">12,415</td>
            <td class="numeric">2,690</td>
            <td class="numeric">336.2</td>
          </tr>
          <tr>
            <td>2</td>
            <td>TMMI</td>
            <td>Assembly 2</td>
            <td class="numeric">10,376</td>
            <td class="numeric">2,248</td>
            <td class="numeric">281.0</td>
          </tr>
          <tr>
            <td>3</td>
            <td>TMMI</td>
            <td>Bodyweld 2</td>
            <td class="numeric">9,572</td>
            <td class="numeric">2,074</td>
            <td class="numeric">259.2</td>
          </tr>
          <tr>
            <td>4</td>
            <td>TMMI</td>
            <td>Paint 2</td>
            <td class="numeric">7,783</td>
            <td class="numeric">1,686</td>
            <td class="numeric">210.8</td>
          </tr>
          <tr>
            <td>5</td>
            <td>TMMI</td>
            <td>Plastics 1</td>
            <td class="numeric">6,604</td>
            <td class="numeric">1,431</td>
            <td class="numeric">178.9</td>
          </tr>
          <tr>
            <td>6</td>
            <td>TMMI</td>
            <td>Assembly 1</td>
            <td class="numeric">6,270</td>
            <td class="numeric">1,359</td>
            <td class="numeric">169.8</td>
          </tr>
          <tr>
            <td>7</td>
            <td>TMMTX</td>
            <td>Bodyweld 1</td>
            <td class="numeric">4,812</td>
            <td class="numeric">1,043</td>
            <td class="numeric">130.4</td>
          </tr>
          <tr>
            <td>8</td>
            <td>TMMK</td>
            <td>Assembly</td>
            <td class="numeric">3,940</td>
            <td class="numeric">854</td>
            <td class="numeric">106.7</td>
          </tr>
        </tbody>
      </table>
    </div>
  </article>

</section>
